import Cookies from 'js-cookie';
import {
  CHARACTER_STATUS,
  GENDER_STATUS,
  IMAGE_STATUS,
  ITEM_JOB_TYPE,
  LINK_DISPLAY_PAGE_AFTER_LOGIN,
  NUMBER_RANGE_YEAR_REGISTER,
  SHOW_STATUS,
} from '../config/constants';
import {
  contentDescriptionTagDefault,
  memberTypeArray,
  sexArray,
  smsStatusOtp,
  textTitleDefault,
} from '../common/constant_text';
import routes from '../routes';

export const renderElementByStatus = (element, status, user) => {
  if (!user) {
    return;
  }

  const { gender, charaStatus } = user;

  if (status === SHOW_STATUS.SHOW
    || (status === SHOW_STATUS.ONLY_MALE && gender === GENDER_STATUS.MALE)
    || (status === SHOW_STATUS.ONLY_FEMALE && gender === GENDER_STATUS.FEMALE)
    || (status === SHOW_STATUS.ONLY_USER && charaStatus === CHARACTER_STATUS.USER)
    || (status === SHOW_STATUS.ONLY_CHARACTER && charaStatus === CHARACTER_STATUS.CHARACTER)
  ) {
    return element;
  }

  return;
};

export const checkLocation = (pages = [], location, isIcon = false) => {
  let textCheck = null;
  if (location && location.pathname.match('/user') !== null && location.pathname.match('/edit') !== null) {
    textCheck = '/mypagemale';
  }
  for (let index = 0; index < pages.length; index++) {
    if (location?.pathname === pages[index]) {
      textCheck = location.pathname.match(pages[index])[0];
    }
  }

  if (pages.includes(textCheck)) {
    return {
      ...isIcon && {
        width: '1em',
        height: '1em',
        fontSize: 24,
        fill: 'currentColor',
      },
      color: 'var(--sub-color)',
      classActive: 'd-svg-icon1-bottom-active'
    };
  }

  return {
    ...isIcon && {
      width: '1em',
      height: '1em',
      fontSize: 24,
      fill: 'currentColor',
    },
    color: 'var(--bottom-color)',
    classInActive: 'd-svg-icon1-bottom'
  };
};

export const agreePathActiveMybPage = () => {
  return [
    '/mypagefemale',
    '/mypagemale',
    '/point/buy',
    '/info',
    '/profile-edit',
    '/account',
    '/myprofile',
    '/favorite',
    '/favorite-job',
    '/footprint',
    '/point',
    '/contactafterlogin',
    '/help',
    '/info-account',
    '/change-phone',
    '/change-login-method',
    '/change-email',
    '/blocklist',
    '/contactageverification',
  ];
};

export const setLocalStorage = (key = '', dataString = '') => {
  if (key) {
    localStorage.setItem(key, dataString);
  }
};

export const getLocalStorage = (key = '') => {
  if (key) {
    return localStorage.getItem(key);
  }
  return null;
};

export const removeLocalStorage = (key = '') => {
  if (key) {
    localStorage.removeItem(key);
  }
};

export const setCookies = (key = '', dataString = '') => {
  if (key) {
    Cookies.set(key, dataString);
  }
};

export const getCookies = (key = '') => {
  if (key) {
    return Cookies.get(key);
  }
  return null;
};

export const removeCookies = (key = '') => {
  if (key) {
    Cookies.remove(key);
  }
};

export const deleteAllCookies = () => {
  const cookies = document.cookie.split(';');

  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i];
    const eqPos = cookie.indexOf('=');
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT';
  }
};

export const textFooterEnv = (envInfoList = []) => {
  return (envInfoList ?? []).find(t => t.code === 'web_footer_text')?.content;
};

export const displayImage = (x) => {
  let imageUrl = require('assets/image-icon/no_user_photo.png');

  if (x?.avatar && x.avatar?.inspection !== IMAGE_STATUS.PENDDING) {
    imageUrl = x?.avatar?.url;
  } else if (x?.url && x?.inspection !== IMAGE_STATUS.PENDDING) {
    imageUrl = x?.url;
  }

  return imageUrl;
};

export const validURL = (str) => {
  const pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
    '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
    '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator

  return !!pattern.test(str);
};

export const pathDisplayPageAfterLogin = (numberPage) => {
  if (LINK_DISPLAY_PAGE_AFTER_LOGIN[numberPage]) {
    return LINK_DISPLAY_PAGE_AFTER_LOGIN[numberPage];
  }

  // Default show page home
  return `${process.env.RAZZLE_PUBLIC_URL}/home`
};

export const convertMemberTypeText = (numberMemberType) => {
  let text = '月額会員';
  const findText = memberTypeArray.find(ele => ele.id === numberMemberType);
  if (findText) {
    text = findText.value;
  }

  return text;
};

export const convertSexText = (numberSex) => {
  let text = '';
  const findText = sexArray.find(ele => ele.id === numberSex);
  if (findText) {
    text = findText.value;
  }

  return text;
};

export const convertSmsStatusText = (status) => {
  let text = '';
  const findText = smsStatusOtp.find(ele => ele.id === +status);
  if (findText) {
    text = `SMS OTP sending ${findText.value}`;
  }

  return text;
};

export const yearRangeRegister = () => {
  let yearCurrent = new Date().getFullYear();
  return new Array(NUMBER_RANGE_YEAR_REGISTER).fill(1)
    .map((x, i) => ({ id: (yearCurrent - i), label: `${yearCurrent - i}` }))
    .reverse();
};

export const monthRange = () => {
  return new Array(12).fill(1)
    .map((x, i) => ({ id: (1 + i), label: `${1 + i}月` }));
};

export const dayRange = () => {
  return new Array(31).fill(1)
    .map((x, i) => ({ id: (1 + i), label: `${1 + i}` }));
};

export const fixedHeaderSticky = (sectionScrollElement, stickyContent, options = {}) => {
  const mainHeader = document.getElementById('header-section');
  const wrapperBoxMsg = document.getElementById('wrapper-box-msg');
  if (!stickyContent.length || !mainHeader || !wrapperBoxMsg) {
    return;
  }
  if (sectionScrollElement.scrollTop > 15) {
    mainHeader.firstElementChild.classList.add('sticky-content-fixed');
  }

  wrapperBoxMsg.style.cssText = `
    margin-top: ${mainHeader.firstElementChild.offsetHeight + 10}px;
    height: calc(100% - ${mainHeader.firstElementChild.offsetHeight + 10}px);
  `;
};

export const convertEnvInfo = (data, filter, regex = false) => {
  if (!data || !Array.isArray(data) || !data.length) {
    return {};
  }

  const objKey = data.reduce((items, curr) => (items[curr.code] = curr, items), {});

  if (!regex && filter && Array.isArray(filter) && filter.length) {
    Object.keys(objKey).filter(key => {
      return !filter.includes(key);
    }).forEach(key => delete objKey[key]);
  }

  if (regex && filter && Array.isArray(filter) && filter.length) {
    for (let key in objKey) {
      for (let item of filter) {
        if (!(new RegExp(item).test(key))) {
          delete objKey[key];
        }
      }
    }
  }

  return objKey;
};

export const renderHiddenElementPreviewIframe = (classListHidden) => {
  if (Array.isArray(classListHidden) && classListHidden.length) {
    for (let item of classListHidden) {
      if (!item) {
        continue;
      }
      document.querySelectorAll(item).forEach(ele => {
        if (item === '.pointer-events-none') {
          ele.style.cssText += 'pointer-events: none';
          return;
        }
        // ele.classList.add('d-none');
        // ele.style.display = 'none';
        ele.remove();
      });
    }
  }
};

export const renderSearchBoxItemJob = (itemJobResources, attribute = {}) => {
  // List Group Resource Item
  const itemParent = {};

  const resourceChildren = (itemJobResources).reduce((accumulator, currentItem) => {
    const keyItem = currentItem['item'];
    // handle Item Parent
    if (currentItem.value === ITEM_JOB_TYPE.ROOT) {
      // Check Item Parent is exist in List Group Resource Item
      if (!itemParent[keyItem]) {
        itemParent[keyItem] = {};
      }
      // Title of Resource Item
      itemParent[keyItem]['title'] = currentItem.label;
      itemParent[keyItem]['showDisplay'] = currentItem.showDisplay;
      // Item Order to specify the order displayed on the Item Screen
      itemParent[keyItem]['searchOrder'] = currentItem.searchOrder;
      itemParent[keyItem]['searchType'] = currentItem.searchType;
      itemParent[keyItem]['selected'] = attribute && attribute[keyItem];
    }

    // Handle Item Children
    if (currentItem.value !== ITEM_JOB_TYPE.ROOT) {
      // Group By Profile Parent
      if (!accumulator[keyItem]) {
        accumulator[keyItem] = [];
      }
      accumulator[keyItem].push(currentItem);
    }
    return accumulator;
  }, []);

  for (let key in itemParent) {
    itemParent[key]['selectedObj'] = (resourceChildren[key] ?? []).find(val => val.value === itemParent[key].selected);
  }

  return {
    itemParent,
    resourceChildren,
  };
};

export const showItemJobText = (list, data) => {
  if (data && Array.isArray(data)) {
    let result = {};
    data.map((item) => {
      list.forEach(profile => {
        if (profile.value === item) {
          result[item] = profile.label;
        }
      });
    });

    return Object.values(result).map(ele => `<span class="d-symbol-search">${ele}</span>`).join('');
  } else {
    return list.find((item) => item.value === data)?.label;
  }
};

export function fullwidthToHalfwidthNumber(value) {
  let result = value.replace(/[\uff01-\uff5e]/g, function (ch) {
    return String.fromCharCode(ch.charCodeAt(0) - 0xfee0);
  });
    return result;
  }

export const getDomainViaName = (url) => {
  let y = new URL(url);
  let result = { keyU: '', mt: '' }
  if (y.hostname.includes('master-app')) {
    result.keyU = 'MASTER_APP';
    result.mt = 'master-app';
  } else if (y.hostname.includes('find-people')) {
    result.keyU = 'FIND_PEOPLE';
    result.mt = 'find-people';
  }  else if (y.hostname.includes('gunma-job')) {
    result.keyU = 'GUNMA_JOB';
    result.mt = 'gunma-job';
  } else if (y.hostname.includes('m-sys-online')) {
    result.keyU ='M_SYS_Online';
    result.mt ='m-sys-online';
  } else if (y.hostname.includes('building-test')) {
    result.keyU ='BUILDING_TEST';
    result.mt ='building-test';
  }

  return result
}

export const convertTextTitleDefault = (mt) => {
  return textTitleDefault[getDomainViaName(mt).keyU] || '';
};

export const convertDescriptionTagDefault = (mt) => {
  return contentDescriptionTagDefault[getDomainViaName(mt).keyU] || '';
};

export const checkStingConcat = (str1 = '', str2 = '') => {
  return [str1.includes(str2), str1.includes(str2)].includes(true);
};

export const getParamByString = (path = '', str = '') => {
  if (path.includes(':')) {
    let pStr = {};
    let lop = 0;
    const sp = path.split('/').map((e, index) => {
      if (e.charAt(0) === ':') {
        ++lop;
        pStr[e.slice(1)] = lop;
        return '([^?]*)';
      }
      return e;
    }).join('/') + '$';

    const regExp = new RegExp(sp);
    const dt = (str || '').match(regExp);

    if (dt) {
      for (const k in pStr) {
        pStr[k] = dt[pStr[k]] || null;
      }
      return pStr;
    }
  }

  return {};
};

export const checkExitsParam = (path = '', str = '') => {
  if (path.includes(':')) {
    const sp = path.split('/').map(e => {
      if (e.charAt(0) === ':') {
        return '([^?]*)';
      }
      return e;
    }).join('/') + '$';

    const regExp = new RegExp(sp);
    return regExp.test(str);
  }

  return false;
};

export const checkExitsUrl = (url = '') => {
  return routes.find(e => {
    if (e.path.includes(':')) {
      return checkExitsParam(e.path, url);
    }

    return checkStingConcat(e.path, url);
  });
};


export const findTagViaElementTitle = (data = '') => {
  let mText = (data || '').match(/<title[^>]*>([^<]+)<\/title>/);
  return Array.isArray(mText) && mText.length > 1 ? mText[1].trim() : '';
};

export const parseJwtServerValid = (token = '') => {
  try {
    return JSON.parse(Buffer.from(token.split('.')[1], 'base64').toString());
  } catch (e) {
    return {};
  }
};

export const parseCookie = (str = '') => {
  return str
      .split(';')
      .map(v => v.split('='))
      .reduce((acc, v) => {
        acc[decodeURIComponent(v[0]?.trim())] = decodeURIComponent(v[1]?.trim());
        return acc;
      }, {});
};


export const serializeFormData = function(obj, prefix) {
  var str = [],
    p;
  for (p in obj) {
    if (obj.hasOwnProperty(p)) {
      var k = prefix ? prefix + '[' + p + ']' : p,
        v = obj[p];
      str.push((v !== null && typeof v === 'object') ?
        serializeFormData(v, k) :
        encodeURIComponent(k) + '=' + encodeURIComponent(v));
    }
  }

  return str.join('&');
};
export const informationBase64 =
  `data:image/png;base64,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`;